// Example retail product used to preview listing templates.
// Purely presentational placeholder data — real product fields will be wired later.

export const exampleProduct = {
  title: "Borraq Heritage All-Purpose Leather Saddle",
  brand: "Borraq Saddlery",
  shortDescription:
    "A handcrafted all-purpose saddle built from full-grain Australian leather, designed for comfort in the arena and durability on the trail.",
  fullDescription: [
    "The Borraq Heritage is our most versatile saddle — equally at home in the arena, on the trail, or out on a long ride. Each saddle is handcrafted from full-grain Australian vegetable-tanned leather that softens and develops a rich patina with every ride.",
    "A hand-stuffed, wool-flocked panel contours to your horse for even weight distribution, while the balanced, close-contact seat keeps you centred through every gait. The reinforced polymer tree is engineered to flex naturally without compromising structure, giving you a secure ride season after season.",
    "Every saddle is finished with solid brass hardware, double-stitched stress points, and a five-year structural warranty. It is built to be repaired, re-flocked and loved for decades — not replaced.",
  ],
  keyFeatures: [
    "Handcrafted from full-grain Australian leather",
    "Balanced close-contact seat for a secure ride",
    "Wool-flocked, hand-stuffed panel for even weight distribution",
    "Reinforced polymer tree with natural flex",
    "Solid brass hardware and double-stitched stress points",
    "5-year structural warranty included",
  ],
  images: [
    {
      src: "https://readdy.ai/api/search-image?query=A%20handcrafted%20premium%20English%20leather%20equestrian%20saddle%20in%20rich%20warm%20tan%20leather%20with%20fine%20contrast%20stitching%20and%20polished%20brass%20hardware%20resting%20on%20a%20smooth%20wooden%20saddle%20stand%20centered%20against%20a%20soft%20warm%20cream%20studio%20backdrop%20with%20gentle%20natural%20window%20light%20and%20subtle%20shadows%20editorial%20high%20end%20product%20photography%20crisp%20focus%20elegant%20minimal%20composition&width=1600&height=900&seq=template-hero-saddle&orientation=landscape",
      alt: "Borraq Heritage leather saddle on a wooden stand",
    },
    {
      src: "https://readdy.ai/api/search-image?query=Extreme%20close%20up%20of%20premium%20tan%20leather%20equestrian%20saddle%20showing%20fine%20grain%20texture%20hand%20stitched%20contrast%20thread%20and%20polished%20brass%20buckle%20hardware%20on%20warm%20cream%20studio%20background%20with%20soft%20directional%20lighting%20and%20gentle%20shadows%20luxury%20product%20detail%20photography%20shallow%20depth%20of%20field%20crisp%20and%20elegant&width=1200&height=900&seq=template-detail-leather&orientation=landscape",
      alt: "Close-up of leather grain and contrast stitching",
    },
    {
      src: "https://readdy.ai/api/search-image?query=A%20premium%20tan%20leather%20equestrian%20saddle%20gently%20placed%20on%20a%20beautiful%20bay%20horse%20standing%20in%20a%20bright%20rustic%20stable%20with%20wooden%20beams%20and%20soft%20golden%20afternoon%20light%20streaming%20through%20warm%20inviting%20atmosphere%20lifestyle%20equestrian%20photography%20natural%20tones%20shallow%20depth%20of%20field%20cinematic%20and%20authentic&width=1600&height=900&seq=template-lifestyle-saddle&orientation=landscape",
      alt: "Saddle on a bay horse in a rustic stable",
    },
    {
      src: "https://readdy.ai/api/search-image?query=Three%20quarter%20rear%20angle%20view%20of%20a%20handcrafted%20premium%20tan%20leather%20equestrian%20saddle%20showing%20the%20sculpted%20cantle%20and%20seat%20displayed%20on%20a%20wooden%20stand%20against%20a%20warm%20cream%20studio%20background%20soft%20even%20lighting%20with%20gentle%20shadows%20high%20end%20product%20photography%20minimal%20and%20refined%20composition&width=1200&height=900&seq=template-angle-saddle&orientation=landscape",
      alt: "Rear angle view of the saddle",
    },
    {
      src: "https://readdy.ai/api/search-image?query=Detail%20view%20of%20polished%20brass%20stirrup%20bar%20and%20leather%20keeper%20on%20a%20premium%20tan%20leather%20equestrian%20saddle%20warm%20cream%20studio%20background%20soft%20diffused%20lighting%20with%20subtle%20highlights%20on%20the%20metal%20luxury%20product%20macro%20photography%20elegant%20and%20minimal&width=1200&height=900&seq=template-hardware-saddle&orientation=landscape",
      alt: "Polished brass hardware detail",
    },
  ],
  sku: "BRQ-HER-AP-17",
  price: "A$1,249.00",
  wasPrice: "A$1,395.00",
  condition: "New",
  variants: [
    { name: "Colour", options: ["Tan", "Dark Brown", "Black"] },
    { name: "Seat Size", options: ["16 in", "17 in", "17.5 in"] },
  ],
  specifications: [
    { label: "Brand", value: "Borraq Saddlery" },
    { label: "Model", value: "Heritage All-Purpose" },
    { label: "Material", value: "Full-grain Australian leather" },
    { label: "Tree", value: "Reinforced polymer, medium" },
    { label: "Gullet Width", value: "Medium (7 in)" },
    { label: "Panel", value: "Wool-flocked, hand-stuffed" },
    { label: "Seat Size", value: "17 in" },
    { label: "Weight", value: "6.8 kg" },
    { label: "Colour", value: "Tan" },
    { label: "Hardware", value: "Solid brass" },
  ],
  dimensions: "66 × 43 × 20 cm",
  weight: "6.8 kg",
  material: "Full-grain Australian leather",
  colour: "Tan",
  size: "17 in seat",
  warranty: "5-year structural warranty",
  shipping: {
    title: "Shipping",
    lines: [
      "Free standard shipping Australia-wide on orders over A$99",
      "Dispatched within 1–2 business days from our Sydney warehouse",
      "Express delivery available at checkout",
    ],
  },
  returns: {
    title: "Returns",
    lines: [
      "30-day hassle-free returns for change of mind",
      "Free return shipping for faulty or damaged items",
      "Returned saddles must be in original, unused condition",
    ],
  },
  support: {
    title: "Customer Support",
    lines: [
      "Mon–Fri 8:30am–5:00pm AEST",
      "Call 1800 555 019 or reply to your order confirmation",
      "Fit guidance and flocking advice from our saddle fitters",
    ],
  },
  rating: { score: 4.8, count: 214 },
};

/**
 * Simple product — one image, short copy, few specs, no variants, no brand,
 * no warranty and no returns copy. Used to verify templates degrade gracefully
 * when optional content is missing.
 */
export const simpleProduct = {
  title: "Handmade Bamboo Serving Board",
  shortDescription:
    "A beautifully simple serving board crafted from a single piece of sustainably grown bamboo.",
  fullDescription: [
    "The Willow & Co. serving board is made from a single slab of premium Moso bamboo, hand-sanded to a silky smooth finish and lightly oiled with food-safe mineral oil. It is naturally antibacterial, lightweight and effortless to clean.",
  ],
  keyFeatures: [
    "Sustainably grown Moso bamboo",
    "Food-safe mineral oil finish",
    "Lightweight and easy to carry",
  ],
  images: [
    {
      src: "https://readdy.ai/api/search-image?query=A%20handcrafted%20bamboo%20serving%20board%20in%20warm%20natural%20wood%20grain%20with%20softly%20rounded%20edges%20resting%20on%20a%20bright%20white%20marble%20kitchen%20countertop%20beside%20a%20sprig%20of%20fresh%20green%20herbs%20and%20a%20folded%20linen%20napkin%20soft%20diffused%20natural%20daylight%20clean%20minimal%20food%20styling%20editorial%20product%20photography%20high%20detail&width=1200&height=900&seq=template-simple-board&orientation=landscape",
      alt: "Handmade bamboo serving board on a marble countertop",
    },
  ],
  sku: "WIL-SB-01",
  price: "A$39.00",
  condition: "New",
  variants: [],
  specifications: [
    { label: "Material", value: "Moso bamboo" },
    { label: "Dimensions", value: "40 × 25 × 2 cm" },
    { label: "Care", value: "Hand wash only" },
  ],
  dimensions: "40 × 25 × 2 cm",
  weight: "0.6 kg",
  material: "Moso bamboo",
  colour: "Natural",
  size: "Large",
  shipping: {
    title: "Shipping",
    lines: ["Dispatched within 2 business days"],
  },
  returns: {
    title: "Returns",
    lines: [],
  },
  support: {
    title: "Customer Support",
    lines: ["Mon–Fri 9am–5pm AEST"],
  },
  rating: { score: 4.7, count: 86 },
};

/**
 * Technical product — dense specification set, dimensions/material/compatibility,
 * multiple variants and longer structured content. Used to verify the
 * information-heavy layouts stay readable.
 */
export const technicalProduct = {
  title:
    "ProTorque 3/8\" Drive Digital Torque Wrench — 10–80 Nm with Angle Measurement & Bluetooth Data Logging",
  brand: "ProTorque Industrial",
  shortDescription:
    "A professional-grade digital torque wrench with ±1.5% accuracy, angle measurement and Bluetooth data logging for precision assembly and quality control.",
  fullDescription: [
    "The ProTorque PT380 is a professional-grade digital torque wrench engineered for precision fastening in automotive, aerospace and industrial assembly. Its calibrated strain-gauge sensor delivers ±1.5% accuracy across the full 10–80 Nm range, with a crisp LCD readout and programmable target torque.",
    "Beyond torque, the PT380 measures rotation angle up to 999°, tracks peak and trace values, and records every tightening cycle via Bluetooth to the free ProTorque app for auditable quality control. Five preset torque memories and a torque-then-angle mode streamline repetitive assembly.",
    "The wrench is built around a hardened chrome-vanadium steel ratchet head with a quick-release 3/8\" drive, housed in an ergonomic, oil- and solvent-resistant composite body. Each unit ships with a factory calibration certificate traceable to NIST and a protective blow-moulded case.",
  ],
  keyFeatures: [
    "±1.5% accuracy, calibrated and traceable to NIST",
    "Torque + angle measurement (up to 999°)",
    "Bluetooth data logging via the ProTorque app",
    "5 preset torque memories and torque-then-angle mode",
    "Hardened chrome-vanadium steel ratchet head",
    "2-year warranty with free recalibration",
  ],
  images: [
    {
      src: "https://readdy.ai/api/search-image?query=A%20professional%20digital%20torque%20wrench%20with%20a%20black%20and%20orange%20composite%20body%20and%20polished%20chrome%20vanadium%20steel%20ratchet%20head%20displayed%20horizontally%20on%20a%20dark%20graphite%20workshop%20bench%20with%20subtle%20reflections%20and%20soft%20studio%20lighting%20high%20detail%20industrial%20product%20photography%20clean%20uncluttered%20background&width=1400&height=900&seq=template-tech-wrench-main&orientation=landscape",
      alt: "ProTorque digital torque wrench on a workshop bench",
    },
    {
      src: "https://readdy.ai/api/search-image?query=Extreme%20close%20up%20of%20a%20digital%20torque%20wrench%20LCD%20display%20showing%20a%20glowing%20torque%20reading%20with%20illuminated%20screen%20and%20chrome%20vanadium%20steel%20ratchet%20head%20on%20a%20dark%20workshop%20surface%20shallow%20depth%20of%20field%20soft%20highlights%20industrial%20product%20macro%20photography%20crisp%20and%20precise&width=1200&height=900&seq=template-tech-wrench-display&orientation=landscape",
      alt: "Close-up of the digital torque wrench LCD display",
    },
    {
      src: "https://readdy.ai/api/search-image?query=A%20digital%20torque%20wrench%20stored%20inside%20an%20open%20protective%20blow%20moulded%20carry%20case%20with%20foam%20cutouts%20and%20a%20printed%20calibration%20certificate%20resting%20on%20a%20dark%20charcoal%20background%20overhead%20angle%20industrial%20product%20photography%20clean%20and%20precise&width=1400&height=900&seq=template-tech-wrench-case&orientation=landscape",
      alt: "Torque wrench in a blow-moulded carry case",
    },
  ],
  sku: "PT-380-38",
  price: "A$289.00",
  wasPrice: "A$349.00",
  condition: "New",
  variants: [
    { name: "Drive Size", options: ["1/4 in", "3/8 in", "1/2 in"] },
    { name: "Torque Range", options: ["5–25 Nm", "10–80 Nm", "20–200 Nm"] },
    { name: "Angle Measurement", options: ["Not included", "Included"] },
  ],
  specifications: [
    { label: "Accuracy", value: "±1.5% of reading (clockwise), ±2.0% (counter-clockwise)" },
    { label: "Torque Range", value: "10–80 Nm (7.4–59 ft-lb)" },
    { label: "Angle Range", value: "0–999°" },
    { label: "Drive Size", value: "3/8 in square drive" },
    { label: "Material", value: "Chrome-vanadium steel head, glass-filled nylon body" },
    { label: "Length", value: "420 mm" },
    { label: "Weight", value: "1.4 kg (with batteries)" },
    { label: "Battery", value: "2 × AA (included)" },
    { label: "Display", value: "LCD with backlight, 0.1 Nm resolution" },
    { label: "Calibration", value: "Factory calibrated, NIST-traceable certificate included" },
    { label: "Compatibility", value: "3/8\" sockets and accessories; ProTorque app (iOS 13+, Android 8+)" },
    { label: "Certifications", value: "ISO 6789, ASME B107.14" },
    { label: "Operating Temperature", value: "-10°C to +50°C" },
    { label: "Warranty", value: "2-year warranty, free annual recalibration check" },
  ],
  dimensions: "42 × 5 × 5 cm",
  weight: "1.4 kg",
  material: "Chrome-vanadium steel / glass-filled nylon",
  colour: "Black / orange",
  size: "420 mm",
  warranty: "2-year warranty",
  shipping: {
    title: "Shipping",
    lines: [
      "Free standard shipping Australia-wide",
      "Dispatched within 1 business day from Sydney",
      "Express and international shipping available",
    ],
  },
  returns: {
    title: "Returns",
    lines: [
      "30-day returns for unused tools",
      "Faulty or inaccurate tools replaced or recalibrated free of charge",
      "Calibration certificate must accompany any warranty claim",
    ],
  },
  support: {
    title: "Customer Support",
    lines: [
      "Mon–Fri 7am–6pm AEST",
      "Technical hotline 1800 555 020",
      "Calibration and repair services available",
    ],
  },
  rating: { score: 4.9, count: 312 },
};